import ActionsCrudConstructor from '~/store/utils/ActionsCrudConstructor';
import createReducer from '~/store/utils/createReducer';
import { takeLatest, all } from 'redux-saga/effects';
import {
  findRecordRequest,
  destroyRecordRequest,
  updateRecordRequest,
  createRecordRequest,
  fetchListRecordsRequest,
} from '~/services/fetchApi/farms';
import {
  initLoading,
  setErrors,
  resetState,
  fetchStart,
  fetchDone,
  setCurrent,
  setChangeList,
  fetchListStart,
  fetchListDone
} from '~/store/utils/reducerFns';
import { farmsRoute } from '~/routes'

/* =================================================
  REDUX TYPES
================================================= */
export const FARMS_SET_CURRENT = '@App/farms/FARMS_SET_CURRENT';
export const FARMS_FETCH_START = '@App/farms/FARMS_FETCH_START';
export const FARMS_FETCH_DONE  = '@App/farms/FARMS_FETCH_DONE';
export const FARMS_FETCH_LIST_START = '@App/farms/FARMS_FETCH_LIST_START';
export const FARMS_FETCH_LIST_DONE = '@App/farms/FARMS_FETCH_LIST_DONE';
export const FARMS_SET_ERRORS = '@App/farms/FARMS_SET_ERRORS';
export const CLEAR_STATE = '@App/farms/CLEAR_STATE';
export const FIND_PERSON_REQUEST = '@App/farms/FIND_PERSON_REQUEST';
export const DESTROY_FARMS_REQUEST = '@App/farms/DESTROY_FARMS_REQUEST';
export const UPDATE_FARMS_REQUEST = '@App/farms/UPDATE_FARMS_REQUEST';
export const CREATE_FARMS_REQUEST = '@App/farms/CREATE_FARMS_REQUEST';
export const FETCH_FARMS_REQUEST  = '@App/farms/FETCH_FARMS_REQUEST';
export const FARMS_CHANGE_LIST  = '@App/farms/FARMS_CHANGE_LIST';

/* =================================================
  REDUX REDUCER
================================================= */

const INITIAL_STATE = {
  current:   undefined,
  data:      [],
  errors:    [],
  isLoading: false,
  listIsLoading: false,
  totalData: 0,
};

export default createReducer(
  INITIAL_STATE,
  {
    [CLEAR_STATE]: resetState,
    [FARMS_FETCH_START]: fetchStart,
    [FARMS_FETCH_DONE]:  fetchDone,
    [FARMS_FETCH_LIST_START]: fetchListStart,
    [FARMS_FETCH_LIST_DONE]: fetchListDone,
    [FARMS_SET_ERRORS]: setErrors,
    [FARMS_SET_CURRENT]: setCurrent,
    [DESTROY_FARMS_REQUEST]: initLoading,
    [CREATE_FARMS_REQUEST]: initLoading,
    [UPDATE_FARMS_REQUEST]: initLoading,
    [FARMS_CHANGE_LIST]: setChangeList,
  }
)

/* =================================================
  REDUX ACTIONS
================================================= */
export function clearState() { return { type: CLEAR_STATE } } // Utilizado ao desmontar os componentes
export function findRecord(id, params={}) {
  return {
    type: FIND_PERSON_REQUEST,
    payload: { id, params }
  }
}
export function destroyRecord(id, callbackSuccess) {
  return {
    type: DESTROY_FARMS_REQUEST,
    payload: { id, callbackSuccess }
  }
}

export function updateRecord(id, data, params={}, callbackSuccess=undefined, callbackFailed=undefined) {
  return {
    type: UPDATE_FARMS_REQUEST,
    payload: { id, data, params, callbackSuccess, callbackFailed }
  }
}
export function createRecord(data, params={}, callbackSuccess=undefined, callbackFailed=undefined) {
  return {
    type: CREATE_FARMS_REQUEST,
    payload: { data, params, callbackSuccess, callbackFailed }
  }
}

export function fetchRecords(params='', requestSource=undefined, callbackSuccess=undefined, callbackFailed=undefined) {
  return {
    type: FETCH_FARMS_REQUEST,
    payload: { params, requestSource, callbackSuccess, callbackFailed }
  }
}

/* =================================================
  SAGA ACTIONS
================================================= */
const crudActions = new ActionsCrudConstructor({
  reducerKey: 'farms',

  routes: {
    list: () => farmsRoute.list.build(),
    show: (id) => farmsRoute.show.build({id}),
    new:  (id) => farmsRoute.new.build({id})
  },

  apiRequests: {
    findRecordApi:    findRecordRequest,
    destroyRecordApi: destroyRecordRequest,
    updateRecordApi:  updateRecordRequest,
    createRecordApi:  createRecordRequest,
    fetchListApi:     fetchListRecordsRequest,
  },

  actionTypes: {
    FETCH_START:      FARMS_FETCH_START,
    FETCH_DONE:       FARMS_FETCH_DONE,
    FETCH_LIST_START: FARMS_FETCH_LIST_START,
    FETCH_LIST_DONE:  FARMS_FETCH_LIST_DONE,
    CHANGE_LIST:      FARMS_CHANGE_LIST,
    CHANGE_CURRENT:   FARMS_SET_CURRENT,
    SET_ERRORS:       FARMS_SET_ERRORS,
  }
});

export const saga = all([
  takeLatest(FIND_PERSON_REQUEST, crudActions.showAction),
  takeLatest(DESTROY_FARMS_REQUEST, crudActions.destroyAction),
  takeLatest(UPDATE_FARMS_REQUEST, crudActions.updateAction),
  takeLatest(CREATE_FARMS_REQUEST, crudActions.createAction),
  takeLatest(FETCH_FARMS_REQUEST, crudActions.fetchListAction),
]);